import { module } from 'modujs';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'toggle'
        }
    }

    init() {
        this.closeBind = (e) => {
             if (e.key === "Escape") {
                html.classList.remove('is-vibrating')
            }
        }

        document.addEventListener('keyup', this.closeBind)
    }

    toggle() {
        if(html.classList.contains('is-vibrating')) {
            html.classList.remove('is-vibrating')
        } else {
            html.classList.add('is-vibrating')
        }
    }

    destroy() {
        super.destroy()

        document.removeEventListener('keyup', this.closeBind)
    }
}
